import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getMyParq, createParq, updateParq, deleteParq } from "../api/healthSurvey";

export function useParq() {
    return useQuery({ queryKey: ["parq"], queryFn: getMyParq });
}

export function useCreateParq() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: createParq,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["parq"] }),
    });
}

export function useUpdateParq() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: updateParq,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["parq"] }),
    });
}

export function useDeleteParq() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: deleteParq,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["parq"] }),
    });
}

export function useUpsertParq() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (payload) => {
            const current = qc.getQueryData(["parq"]);
            if (current) return updateParq(payload);
            return createParq(payload);
        },
        onSuccess: () => qc.invalidateQueries({ queryKey: ["parq"] }),
    });
}
